/**
 * Drop the redundant "<b>Name</b>: " prefix from a human agent's message body.
 *
 * mb-bot-app builds the Slack/Teams relay payload as `<b>${displayName}</b>: ${text}`
 * (teamsBot.sendMessageToSocketServer) because the *visitor widget* parses that
 * prefix to label the bubble. mb-server persists the same string, and the SDR
 * inbox renders the agent name separately as the bubble's own label — so the
 * name appeared twice: "ALLISON · HUMAN" above "Allison: <message>".
 * Reported by etherfax 2026-07-31.
 *
 * Only strips when the prefix actually matches the resolved sender, so a message
 * that legitimately opens with "Something:" is never truncated.
 */
export function stripSenderPrefix(content: string, senderName: string | undefined | null): string {
  if (!content || !senderName) return content;
  const escaped = senderName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const prefix = new RegExp(`^\\s*(?:<b>\\s*)?${escaped}(?:\\s*</b>)?\\s*:\\s*`, 'i');
  const stripped = content.replace(prefix, '');
  // Never blank a bubble: if the body was nothing but the prefix, keep the original.
  return stripped.trim() ? stripped : content;
}

export default stripSenderPrefix;
